<template>
  <div>
    <form data-vv-scope="assign-approval" class="mb-3">
      <list-group-users
        class="w-100"
        autocomplete
        label="Usuario"
        name="resendSubject"
        v-model="resendSubject.id"
        :parent-value="stepOfficeId"
        ref="resendName"
        v-validate="'required'"
        :danger="errors.has('assign-approval.resendSubject')"
        :danger-text="errors.first('assign-approval.resendSubject')"
      />
    </form>
    <div>
      <vs-textarea
        class="mb-0"
        maxlength="255"
        label="Comentario"
        v-model="comment"
        name="comment"
        v-validate="'min:5'"
      />
    </div>
    <div  class="text-right">
      <b-button
        class="mt-3 text-right"
        variant="primary"
        @click="sendAction"
      >
        Asignar
      </b-button>
    </div>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';
import {
  VBToggle
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';

import ListGroupUsers from '@/febos/chile/lists/components/ListGroupUsers';
import { stepTypesCode } from '@/febos/chile/approvals/components/trays/managementTray/constants';

export default {
  components: {
    ListGroupUsers
  },
  data() {
    return {
      resendSubject: {},
      comment: ''
    };
  },
  props: {
    file: {
      type: Object
    }
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple
  },
  computed: {
    stepOfficeId() {
      return this.file.tipoValorResponsableId;
    },
    ...mapGetters('Usuario', [
      'currentUser',
    ])
  },
  methods: {
    ...mapActions('Approvals', [
      'assignFileFlow'
    ]),
    cancelProcess() {},
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    makeObjectRequest() {
      const request = {
        idAprobacion: this.file.aprobacionesReferenciaId,
        idEjecucion: this.file.idAprobacion,
        pasoId: this.file.pasoActualId
      };

      const name = this.$refs.resendName && this.$refs.resendName.getOption().label;
      const body = {
        comentario: {
          accion: 'reenviar',
          comentario: this.comment
        },
        documentos: [],
        estado: 'REENVIAR',
        temporalUsuario: name,
        temporalUsuarioId: this.resendSubject.id,
        temporalContinuar: true,
        tipoPaso: stepTypesCode.oficial
      };

      return { request, body };
    },
    async sendAction() {
      const isValid = await this.validateForm('assign-approval');
      if (!isValid) {
        return;
      }
      if (this.resendSubject.id === this.currentUser.id) {
        this.$bvToast.toast(
          'No puedes asignarte a ti mismo como oficial para tramitar el documento',
          {
            title: '¡Hey!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }

      const response = await this.assignFileFlow(this.makeObjectRequest());
      this.$bvToast.toast(
        `${response.mensaje}`,
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      this.$emit('close');
    }
  }
};
</script>
